import UIkit from 'uikit';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeUI_Default from 'photoswipe/src/js/ui/photoswipe-ui-default.js';

export default function () {
    const pswp = UIkit.util.$('.pswp');
    const galleryContainer = UIkit.util.$$('.tm-gallery');
    const options = {};

    UIkit.util.each(galleryContainer, (container) => {
        let items = [];
        let gallery;
        let images = UIkit.util.$$('.tm-gallery__image', container);

        UIkit.util.each(images, (image) => {
            items.push({
                src: image.getAttribute('href'),
                w: image.getAttribute('data-width'),
                h: image.getAttribute('data-height'),
                // msrc: image.getAttribute('data-src'),
                el: image,
            });

            UIkit.util.on(image, 'click', function (e) {
                e.preventDefault();

                let parent = UIkit.util.closest(this, '.tm-gallery__item');
                console.log(parent);
                let index = UIkit.util.index(parent);

                openGallery(index);
            });
        });

    function openGallery(index)
    {
        let options = {
            captionEl: false,
            fullscreenEl: false,
            shareEl: false,
            tapToClose: true,
            tapToToggleControls: false,
          // showAnimationDuration: 0,
            hideAnimationDuration: 0,
            bgOpacity: 0.85,
            index: index,
          // showAnimationDuration: 0,
          /*getThumbBoundsFn: function(index) {
            let thumbnail = items[index].el, // find thumbnail
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();

            return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
          },*/
        };

        gallery = new PhotoSwipe(pswp, PhotoSwipeUI_Default, items, options);
        gallery.init();
    }
    });
}



// WEBPACK FOOTER //
// ./scripts/partials/gallery.js